module.exports = __webpack_public_path__ + "static/media/08_premium_mobile.edf43cfb.mp4";